const ACTION_LABELS = {
  "enquiry.created": "New request submitted",
  "enquiry.assigned": "Request assigned to the Jigsaw team",
  "enquiry.requirement_added": "Requirement added to your request",
  "enquiry.ready_for_placement": "Request marked ready for placement",
  "enquiry.completed": "Request completed",
  "enquiry.cancelled": "Request cancelled",
  "supplier_offer.submitted": "A supplier offer was received",
  "client_offer.presented": "An offer was presented for your decision",
  "client_offer.decided": "You responded to an offer",
  "confirmation.generated": "Booking confirmation issued",
  "booking_change.requested": "A change was requested on your booking",
  "booking_change.applied": "A change was applied to your booking",
  "booking_change.rejected": "A change request was declined",
  "payment.recorded": "A payment was recorded",
  "document.uploaded": "A document was added",
  "client.updated": "Your account details were updated",
};

export function humanizeActivity(action) {
  if (ACTION_LABELS[action]) return ACTION_LABELS[action];
  return action.replace(/[._]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

const LINKABLE_ENTITY_TYPES = {
  enquiry: "/client/requests",
  booking: "/client/bookings",
};

export function activityLink(entityType, entityId) {
  const base = LINKABLE_ENTITY_TYPES[entityType];
  if (!base || !entityId) return null;
  return `${base}/${entityId}`;
}
